import { render, staticRenderFns } from "./msw-report-issues.vue?vue&type=template&id=ef0ce800&scoped=true&"
import script from "./msw-report-issues.vue?vue&type=script&lang=tsx&"
export * from "./msw-report-issues.vue?vue&type=script&lang=tsx&"
import style0 from "./msw-report-issues.vue?vue&type=style&index=0&id=ef0ce800&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef0ce800",
  null
  
)

export default component.exports